import { CompanyPricingPlan, Currency, IntegratorKey, Locale } from "@lib";
import { StringUtils } from "@/utils/string.utils";

export const configuration = {
    about: {
        title: (process.env.VUE_APP_TITLE as string) ?? "Alt SC",
        titleShort: (process.env.VUE_APP_TITLE_SHORT as string) ?? "AltSC",
        description: (process.env.VUE_APP_DESCRIPTION as string) ?? "",
        version: (process.env.APP_VERSION as string) ?? "0.0.0",
        author: process.env.VUE_APP_AUTHOR as string,
        supportEmail: (process.env.VUE_APP_SUPPORT_EMAIL as string) ?? "support@altsc.ru",
        supportTg: (process.env.VUE_APP_SUPPORT_TG as string) ?? "support@altsc.ru",
    },
    api: {
        url: process.env.VUE_APP_API_BASEURL,
    },
    common: {
        /** Интегратор. */
        integrator: (process.env.VUE_APP_INTEGRATOR as IntegratorKey) ?? IntegratorKey.Origin,

        /** Языковой стандарт по умолчанию. */
        locale: (process.env.VUE_APP_DEFAULT_LOCALE as Locale) ?? Locale.RU,

        /** Валюта по умолчанию. */
        currency: (process.env.VUE_APP_DEFAULT_CURRENCY as Currency) ?? Currency.RUB,

        /** Папка с логотипами. */
        logoDirectory: (process.env.VUE_APP_LOGO_DIRECTORY as string) ?? "logo",

        /** Доступность входа через соцсети. */
        socialsEnabled: StringUtils.stringToBoolean(process.env.VUE_APP_SOCIALS_ENABLED) ?? false,

        /** Доступность документации. */
        documentationEnabled: StringUtils.stringToBoolean(process.env.VUE_APP_DOCUMENTATION_ENABLED) ?? false,

        /** Доступность реферальной программы. */
        referralProgramEnabled: StringUtils.stringToBoolean(process.env.VUE_APP_REFERRAL_PROGRAM_ENABLED) ?? false,

        /** Доступность уведомлений. */
        notificationsEnabled: StringUtils.stringToBoolean(process.env.VUE_APP_NOTIFICATIONS_ENABLED) ?? false,

        /** Возможность оплаты доступа через CloudPayments. */
        cloudPaymentsEnabled: StringUtils.stringToBoolean(process.env.VUE_APP_CLOUDPAYMENTS_ENABLED) ?? false,

        /** Возможность писать в техподдержку через виджет. */
        supportWidgetEnabled: StringUtils.stringToBoolean(process.env.VUE_APP_SUPPORT_WIDGET_ENABLED) ?? false,
    },
    url: {
        webapp: process.env.VUE_APP_WEBAPP_BASEURL,
        docs: process.env.VUE_APP_DOCS_BASEURL,
        admin: process.env.VUE_APP_ADMIN_BASEURL,
    },
    prices: {
        free: {
            fee: 0,
            ordersCount: 10,
            salesCount: 10,
            tasksCount: 10,
            currency: Currency.RUB,
            locale: Locale.RU,

            /** Тарифный план после окончания бесплатного периода. */
            nextPlan: (process.env.VUE_APP_STANDART_PRICING_PLAN as CompanyPricingPlan) ?? CompanyPricingPlan.Standart,
        },
        standart: {
            fee: 25,
            currency: Currency.RUB,
            locale: Locale.RU,
        },
        sc24: {
            fee: 18,
            currency: Currency.RUB,
            locale: Locale.RU,
        },
        uposStandart: {
            fee: 16700,
            currency: Currency.UZS,
            locale: Locale.RU,
        },
    },
    integrations: {
        google: {
            /** Google Tag widget id. */
            widgetId: process.env.VUE_APP_GOOGLE_TAG_MANAGER_WIDGETID,
        },
        yandex: {
            /** Яндекс Метрика widget id. */
            widgetId: process.env.VUE_APP_YANDEX_METRIKA_WIDGETID,
        },
        jivo: {
            /** Jivo Site widget id. */
            widgetId: process.env.VUE_APP_JIVOSITE_WIDGETID,
        },
        vk: {
            /** ВК widget id. */
            widgetId: process.env.VUE_APP_VK_WIDGETID,
        },
        yoomoney: {
            /** ЮМани wallet id. */
            walletId: process.env.VUE_APP_YOOMONEY_WALLET_ID,
        },
        cloudPayments: {
            /** Cloud Payments public id. */
            publicId: process.env.VUE_APP_CLOUDPAYMENTS_PUBLICID,
        },
    },
};
